<template>
    <div
        v-if="
            state.currentView == 'OPAY_INIT_VIEW' && state.processing != true
        "
    >
        <h5
            class="container__col-md-12 container__col-sm-12 payment__instruction"
        >
            {{ $t("opay.init.description") }}
        </h5>
        <PrimaryButton :content="$t('opay.pay.btn')" @click="Next" />
    </div>
    <div
        v-else-if="
            state.currentView == 'REDIRECT_VIEW' && state.processing != true
        "
    >
        <RedirectView :redirect-instruction="$t('opay.redirect.description')" @next="Next" />
    </div>
    <div v-else-if="state.currentView == 'CONFIRMING_VIEW' && state.processing != true">
        <p class="container__col-md-12 container__col-sm-12 payment__instruction">
            {{ $t("mm.confirming")}}
        </p>

        <div class="center">
            <div class="loader-icon"></div>
        </div>
    </div> 
</template>

<script>
import { ref, onBeforeUnmount } from "vue";
import { injectStore, mapState } from "redux-vuex";

import { getValueFromPath, autoInitialize } from "@/support/helpers";
import PrimaryButton from "@/components/form/base-button";
import { onUpdated } from "@vue/runtime-core";
import RedirectView from "@/components/common/redirect-view.vue";

export default {
    name: "PayLater",
    components: {
        PrimaryButton,
        RedirectView,
    },

    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());

        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        const autoInitializePayment = autoInitialize("OPAY_INIT_VIEW");

        onUpdated(() =>  autoInitializePayment(checkoutData, Next));

        onBeforeUnmount(() => {
            subscription();
        });

        return {
            state: mapState({
                processing: (state) => getValueFromPath(state, "processing") || false,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
            }),
            getValueFromPath,
            Next,
        };

    },

};
</script>

<style>

</style>